<template>
    <div>
        <header class="pb-3">
            <b-container>
                <b-row>
                    <b-col>
                        <router-link to="/"><img src="@/assets/thepaymentoption-logo-white.svg" class="logo mt-4"/></router-link>
                    </b-col>
                    <b-col class="text-right pt-5" sm="12" md="9">
                        <ul class="menu">
                            <li class="active"><i class="fas fa-credit-card mr-2"></i>Accounts</li>
                            <router-link tag="li" exact-active-class="active" :to="{name: 'messages', params: {code}}">
                                <i class="fas fa-messages mr-2"></i>Messages <span class="message-count" v-if="messageCount">({{ messageCount }})</span>
                            </router-link>
                            <router-link tag="li" exact-active-class="active" :to="{name: 'profile', params: {code}}">
                                <i class="fas fa-user mr-2"></i>Profile<i class="fas fa-exclamation-triangle ml-2" v-if="contactIssues.length" :title="contactIssues.join(', ')"></i>
                            </router-link>
                            <li @click="sessionLogout"><i class="fas fa-sign-out mr-2"></i>Logout</li>
                        </ul>
                    </b-col>
                </b-row>
            </b-container>
        </header>

        <b-container class="mt-5 pb-5 mb-5">
            <b-alert show variant="danger" v-if="needsTextNumber" class="mb-5">
                <div class="mb-3 mt-3">
                    <strong>ACTION REQUIRED</strong>
                </div>
                <p>We do not have a mobile number on file for text messages. Without one you can only log in and approve payment changes by e-mail.</p>
                <p class="pt-2">
                    <b-button class="mt-2" variant="success" :to="{name: 'profile', params: {code}}"><i class="far fa-mobile mr-2"></i>Add Text-Message Number</b-button>
                </p>
            </b-alert>

            <b-row>
                <b-col sm="12" md="12" lg="4">
                    <router-link tag="div" v-for="acct in accounts" :to="{name: 'account', params: {id: acct.id}}" exact-active-class="active" class="account">
                        <div>
                            <h6 class="mb-0">{{ acct.nickname }}</h6>
                            <p class="mb-1 meta">24/7 Educational Services</p>
                            <b-row>
                                <b-col class="meta">R{{ acct.id }}</b-col>
                                <b-col class="total text-right">{{ acct.total - acct.paid | currency }}</b-col>
                            </b-row>
                            <div class="mt-3" v-if="acct.active === 0"><b-badge variant="warning" v-b-popover.hover.top="'Automatic payments for this account have been temporarily suspended. Most likely because you contacted us and we are working on your request. Please contact us if you feel this is a mistake.'"><i class="fas fa-pause-circle mr-2"></i>Automatic Payments Suspended<i class="fal fa-question-circle ml-2"></i></b-badge> </div>
                            <div class="mt-3" v-if="(acct.is_error === 1 || !acct.last_four) && acct.total > 0 && (acct.total - acct.paid) > 0"><b-badge variant="danger"><i class="fas fa-exclamation-circle mr-2"></i>Problem with Account</b-badge> </div>
                        </div>
                    </router-link>
                </b-col>
                <b-col>
                    <router-view @resolve="resolve"/>
                </b-col>
            </b-row>
        </b-container>

        <footer class="pt-3 pb-2">
            <b-container>
                <copyright class="mt-3 mb-3"/>
            </b-container>
        </footer>
    </div>
</template>

<script>
    import Copyright from "../components/Copyright";
    import {mapActions} from "vuex";
    import {contactIssues, needsTextNumber} from '@/utils/contact';

    export default {
        name: "accounts",
        components: {Copyright},
        props: ['id', 'code'],
        data: function() {
            return {
                accounts: [],
                contact: null,
                messageCount: 0
            };
        },
        computed: {
            contactIssues: function() {
                return contactIssues(this.contact);
            },
            needsTextNumber: function() {
                return needsTextNumber(this.contact);
            }
        },
        methods: {
            ...mapActions(['getAccounts', 'getContact', 'getMessages', 'logout']),
            sessionLogout: function() {
                this.logout(this.code).then(() => {
                    console.log('Session destroyed.');
                });
                this.$router.push({name: 'home'});
            },
            resolve: function(id) {
                for (let i = 0; i < this.accounts.length; i++) {
                    const account = this.accounts[i];
                    if (account.id === parseInt(id)) account.is_error = 0;
                }
            }
        },
        mounted: function() {
            // Drives the Profile menu marker and the text-number CTA
            this.getContact(this.code).then(contact => {
                this.contact = contact;
            }, err => {
                console.error(err);
            });

            this.getAccounts(this.code).then(accounts => {
                this.accounts = accounts;
                // Landing on the bare accounts route opens the first plan
                if (this.$route.name === 'accounts' && this.accounts.length) {
                    this.$router.push({name: 'account', params: {id: this.accounts[0].id}});
                }
            }, err => {
                this.$router.push({name: 'home'});
                console.error(err);
            });

            this.getMessages(this.code).then(messages => {
                this.messageCount = messages.length;
            }, err => {
                console.error(err);
            });
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    .meta {
        font-size: 0.9rem;
        color: grey;
    }

    .total {
        font-size: 0.9rem;
        font-weight: bold;
    }

    .account {
        cursor: pointer;
        margin-bottom: 1rem;

        &:hover {
            background-color: #f4f4f4 !important;
        }

        &.active {
            background-color: #f7f7f7 !important;

            > div {
                border-left: 16px solid $green;
            }
        }

        > div {
            border-left: 16px solid #eeeeee;
            padding: 0.8rem 1.3rem;
            border-radius: 0.25rem;
        }

        border-radius: 0.25rem;
        background-color: #f7f7f7;
    }

    header {
        .logo {
            max-width: 160px;
        }

        background: #3c3c5f;
        color: white;

        .menu {
            list-style: none;

            li {
                display: inline-block;
                margin-left: 1rem;
                padding: 0.2rem 1rem;
                border-radius: 1.5rem;
                cursor: pointer;

                &:hover {
                    background-color: rgba(255, 255, 255, 0.15);
                }

                &.active {
                    background-color: white !important;
                    color: #3c3c5f;
                }

                @media only screen and (max-width: 600px) {
                    padding: 0.5rem;
                    margin-left: 0.5rem;
                }
            }

            @media only screen and (max-width: 600px) {
                text-align: left;
                padding: 0;
            }
        }
    }

    footer {
        border-top: 1px solid $gray-300;
        padding: 2rem 0 0;
        margin-top: 2rem;

        .copyright {
            color: $gray-500 !important;
        }
    }

    .fa-exclamation-triangle {
        color: orangered;
    }

    .message-count {
        font-size: 0.9rem;
        opacity: 0.8;
    }
</style>
